import { Button, Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header, PlusIcon, useMinimalsTheme } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useNavigate } from 'react-router'
import { ArchetypeUIStore } from '../../stores/archetype.ui-store'

interface IProps {
  viewStore: ArchetypeUIStore
}

export const ArchetypeHeader: FC<IProps> = observer(({ viewStore }) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const navigate = useNavigate()

  const title = t('archetypes', 'Archetypes')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <Header
      title={title}
      searchInputLabel={t('searchForArchetype', 'Search for an archetype')}
      breadcrumbs={breadcrumbs}
      onSearchFieldChange={filter => viewStore.setFilter(filter)}
      displaySearchIcon
      enableSearchField
      rightRenderOption={
        <Stack flexDirection='row' gap={theme.customSpacing.xs}>
          <Button
            color='inherit'
            variant='contained'
            sx={{ flex: 'none' }}
            startIcon={<PlusIcon />}
            onClick={() => navigate('new')}
          >
            {t('addNew', 'Add new')}
          </Button>
        </Stack>
      }
    />
  )
})
